export default {
  title: 'Zahlungsgateways',
  fields: {
    name: 'Name',
    payment_gateway: 'Zahlungsgateways',
    live_from: 'Live seit',
    last_30_days_sales: 'Umsatz letzte 30 Tage',
    kyc_deadlines: 'KYC-Fristen',
    actions: 'Aktionen',
  },
  stats: {
    active_on_stripe: 'Aktiv auf Stripe',
    active_on_adyen: 'Aktiv auf Adyen',
    adyen_verification_pending: 'Adyen-Verifizierung ausstehend',
  },
  filters: {
    search_placeholder: 'Nach Name suchen...',
    gateway_status_placeholder: 'Alle Gateways',
  },
  not_configured: {
    title: 'Zahlungen sind noch nicht konfiguriert',
    description:
      'Für dein Konto ist noch kein Zahlungsanbieter verbunden. Restaurants können vollständig eingerichtet werden, aber erst live gehen und Online-Zahlungen annehmen, sobald Zahlungen konfiguriert sind.',
  },
  gateway_statuses: {
    stripe_as_primary: 'Stripe',
    adyen_as_primary: 'Adyen',
    adyen_pending: 'Adyen (Ausstehend)',
  },
  gateways: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
  verification_statuses: {
    verified: 'Verifiziert',
    pending: 'Ausstehend',
    rejected: 'Abgelehnt',
  },
  buttons: {
    actions: 'Aktionen',
    switch_to: 'Wechseln zu {{gateway}}',
    view_details: 'Details anzeigen',
    open_onboarding: 'Onboarding öffnen',
    create_onboarding_link: 'Onboarding-Link erstellen',
  },
  modal: {
    title: 'Zahlungsgateway wechseln',
    description:
      'Sind Sie sicher, dass Sie {{companyName}} von <bold>{{currentGateway}}</bold> auf <bold>{{targetGateway}}</bold> umstellen möchten?',
    not_verified_warning:
      '{{gateway}} ist für dieses Unternehmen nicht verifiziert. Die Zahlungsverarbeitung kann beeinträchtigt werden.',
    confirm: 'Wechseln',
    cancel: 'Abbrechen',
  },
  details_modal: {
    title: '{{companyName}} — Zahlungsgateway-Details',
    requirements: 'Anforderungen',
    no_requirements: 'Keine ausstehenden Anforderungen.',
    deadline: 'Frist',
    capabilities: 'Fähigkeiten',
    onboarding_links: {
      section_title: 'Onboarding-Link',
      active_link: 'Aktiver Link',
      expires: 'Gültig bis {{date}}',
      create_button: 'Link erstellen',
      extend_button: 'Link verlängern',
      loading: 'Links werden geladen…',
    },
  },
  toasts: {
    onboarding_link_failed: 'Onboarding-Link konnte nicht erstellt werden.',
    switch_success: 'Zahlungsgateway erfolgreich gewechselt.',
    switch_failed: 'Zahlungsgateway konnte nicht gewechselt werden.',
    failed_to_load_data: 'Daten konnten nicht geladen werden.',
  },
};
